import { motion } from "framer-motion";
import { useLanguage } from "../lib/LanguageContext";
import { CONTACT } from "../lib/translations";

export default function Closing() {
  const { t } = useLanguage();
  const waLink = `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent("Hola Amaranto, quisiera más información sobre los kits.")}`;
  return (
    <section data-testid="closing-section" className="relative bg-warmbrown-deep text-cream py-32 md:py-44 overflow-hidden">
      <div className="absolute inset-0 opacity-25" style={{ backgroundImage: "url(/catalog/img14.jpg)", backgroundSize: "cover", backgroundPosition: "center" }} aria-hidden />
      <div className="absolute inset-0 bg-gradient-to-b from-warmbrown-deep/85 via-warmbrown-deep/75 to-warmbrown-deep/95" />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 1.2 }}
        className="relative max-w-3xl mx-auto px-6 md:px-12 text-center"
      >
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-10 h-px bg-champagne" />
          <span className="eyebrow !text-champagne">{t.closing.eyebrow}</span>
          <div className="w-10 h-px bg-champagne" />
        </div>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-cream">
          {t.closing.title1}
          <br />
          <span className="italic font-normal text-champagne">{t.closing.title2}</span>
        </h2>
        <a href={waLink} target="_blank" rel="noreferrer" data-testid="closing-cta"
          className="inline-flex items-center gap-3 mt-12 bg-cream hover:bg-dustyrose text-warmbrown-deep px-10 py-4 text-[11px] tracking-[0.3em] uppercase font-semibold transition-all duration-500">
          {t.closing.cta} →
        </a>
      </motion.div>
    </section>
  );
}
